import React, { useState, useEffect, useCallback } from "react";
import { notification } from "antd";
import { useNavigate } from "react-router-dom";
import { apiServices } from "../services/Api";
import Loader from "../components/Loader";
import leftarrow from "../assets/images/u_angle-left-b.svg";
import CustomerCard from "../components/Dashboard/CustomerCard";

const NotifiedCalls = () => {
  const navigate = useNavigate();
  const [notifiedCalls, setNotifiedCalls] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchNotifiedCalls = useCallback(async () => {
    setIsLoading(true);
    try {
      const response = await apiServices.get("/users/calls/notify");
      console.log("Notified calls:", response);

      if (Array.isArray(response)) {
        setNotifiedCalls(response);
      } else {
        setNotifiedCalls([]);
      }
    } catch (error) {
      console.error("Error fetching notified calls:", error);
      notification.error({
        message: "Error",
        description: "Failed to load notified calls. Please try again.",
      });
      setNotifiedCalls([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNotifiedCalls();
  }, [fetchNotifiedCalls]);

  const handleUnsubscribe = async (callId) => {
    try {
      await apiServices.post(`/users/calls/notify`, {
        callId: callId,
      });

      notification.success({
        message: "Success",
        description: "You have been unsubscribed from this call.",
      });

      fetchNotifiedCalls();
    } catch (error) {
      console.error("Unsubscribe error:", error);
      notification.error({
        message: "Error",
        description: "Failed to unsubscribe. Please try again.",
      });
    }
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div className="min-h-screen bg-[#f5f7fa] p-4 lg:p-6">
      <div className="max-w-[1440px] mx-auto">
        <div className="max-w-[1440px] mx-auto ">
          <div className="mb-6 bg-white shadow-sm  border-b border-t border-brand-border">
            <div className="flex items-center justify-start p-4 lg:p-6 flex-row gap-4">
              <h2 className="text-xl lg:text-[24px] xl:text-[24px] font-semibold text-[#454545]">
                Notified Calls ({notifiedCalls.length})
              </h2>
            </div>
          </div>
        </div>
        {notifiedCalls.length === 0 ? (
          <div className="bg-white p-8 lg:p-12 rounded-lg text-center mx-8">
            <div className="text-gray-400 text-6xl mb-4">🔔</div>
            <h3 className="text-xl lg:text-2xl font-semibold text-gray-700 mb-2">
              No Notified Calls
            </h3>
            <p className="text-gray-500 mb-6">
              You haven't subscribed to any trading calls yet.
            </p>
            <button
              onClick={() => navigate("/dashboard")}
              className="bg-primary text-white px-6 py-2.5 lg:py-3 rounded-lg font-medium hover:bg-primary/90 transition-colors"
            >
              Browse Calls
            </button>
          </div>
        ) : (
          <div className="flex flex-col gap-4 lg:gap-6">
            {notifiedCalls.map((call) => (
              <CustomerCard
                key={call.id}
                data={{
                  ...call,
                  id: call.id || call.callId,
                  duration:
                    call.duration !== undefined
                      ? call.duration
                      : call.holdingDurationInDays,
                }}
                sourcePage="/notified-calls"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default NotifiedCalls;
